import React from 'react';
import { DataTable } from '@trackman/react-ui';
import styled from 'styled-components';
import { brand, white } from 'styles/Colors';

export const SearchResultsWrapper = styled.div`
  margin: auto;
`;

export const StyledDataTable = styled((props) => <DataTable {...props} />)`
  background-color: ${white};
  .DayPickerInput input:focus {
    outline: none;
  }

  .verified-checkbox .checkbox {
    background-color: ${brand} !important;
    color: ${brand} !important;
    cursor: default;
    margin-top: 17px;
    margin-left: 20px;
  }

  .table-cell {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 2px;
  }
`;

export const TitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
